import React, { useEffect, useState, Component } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// Fix for default marker icon in react-leaflet
const defaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
export const MapComponent = () => {
  const [isMounted, setIsMounted] = useState(false);
  // Coordinates for 296 Francis Baard Street, Pretoria
  const position: [number, number] = [-25.7461, 28.1881];
  useEffect(() => {
    setIsMounted(true);
    // Cleanup Leaflet elements on unmount
    return () => {
      setIsMounted(false);
    };
  }, []);
  if (!isMounted) {
    return <div className="h-full min-h-[250px] bg-gray-800 rounded-lg animate-pulse" data-id="element-165"></div>;
  }
  return <MapContainer center={position} zoom={15} style={{
    height: '100%',
    minHeight: '250px',
    width: '100%',
    borderRadius: '0.5rem'
  }} scrollWheelZoom={false} data-id="element-166">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-167" />
      <Marker position={position} icon={defaultIcon} data-id="element-168">
        <Popup data-id="element-169">
          Binary Solutions 101010 <br data-id="element-170" />
          296 Francis Baard Street <br data-id="element-171" />
          Office 0314, Pretoria CBD
        </Popup>
      </Marker>
    </MapContainer>;
};